// Rough extents of Victoria in Lat and Lon
export const TOP_OF_VICTORIA = -33.5;
export const BOTTOM_OF_VICTORIA = -39.3;
export const LEFT_OF_VICTORIA = 140.7;
export const RIGHT_OF_VICTORIA = 150.2;

export const MODES = {
  UNSET: 'UNSET',
  WILDFIRE: 'WILDFIRE',
  PLANNED_BURNS: 'PLANNED_BURNS',
  HINDSIGHT: 'HINDSIGHT'
};

export const OVERLAY_KEYS = {
  WEATHER_STATIONS: 'AWS',
  FUEL_MOISTURE_STATIONS: 'FMS',
  WIND_ANIMATED: 'HP_WINDY',
  WIND_BARBS: 'HP_BARB'
};

export const INCIDENT_TYPE_KEYS = {
  BUSHFIRES: 'BUSHFIRES',
  CURRENT_BURNT_AREA: 'CURRENT_BURNT_AREA',
  BURNS: 'BURNS',
  INCIDENT_POLYGONS: 'INCIDENT_POLYGONS',
  INCIDENT_PRESCRIPTIONS: 'INCIDENT_PRESCRIPTIONS'
};

export const INCIDENT_PRESCRIPTION_STATUS = {
  NO_PRESCRIPTION: 'NO_PRESCRIPTION',
  UNKNOWN_PRESCRIPTION: 'UNKNOWN_PRESCRIPTION',
  PRESCRIPTION_NOT_LOADED: 'PRESCRIPTION_NOT_LOADED',
  PRESCRIPTION_LOADED: 'PRESCRIPTION_LOADED'
};

export const INCIDENT_STATUSES = ['GOING', 'CONTAINED', 'CONTROLLED', 'UNDER CONTROL - 1', 'UNDER CONTROL - 2'];

export const AEROLOGICAL_WS = [
  94865, 94821, 94910, 94672
];

export const WIND_DATA_STATUS = {
  NOT_LOADED: 'NOT_LOADED',
  LOADING: 'LOADING',
  LOADED: 'LOADED'
};

// The Key and Display Name of each Data Set
export const DATA_SETS = {
  WEATHER: 'Weather',
  MCARTHUR_MK5: 'McArthur Mk5',
  VESTA: 'VESTA',
  VESTA_MK2_DRY: 'VESTA MkII Dry',
  VESTA_MK2_WET: 'VESTA MkII Wet',
  LEAFLET_80: 'Leaflet 80',
  GRASS: 'Grass',
  MALLEE_HEATH: 'Mallee Heath',
  PRESCRIPTIONS: 'Prescriptions',
  ISP: 'ISP'
};

export const TABLE_BACKGROUNDS = {
  NONE: 'NONE',
  COLOR: 'COLOR',
  GRAPH: 'GRAPH'
};

export const TABLE_DIRECTIONS = {
  ARROWS: 'ARROWS',
  NUMBERS: 'NUMBERS',
  CARDINALS: 'CARDINALS'
};

// The Key and Display Name of each export format
export const EXPORT_FORMATS = {
  PHOENIX: 'Phoenix (CSV)',
  WEATHER: 'Simple Weather',
  DETAILED_WEATHER: 'Detailed Weather',
  SIMPLE_PLUS_BEHAVIOUR: 'Simple Weather + Fire Behaviour',
  DETAILED_PLUS_BEHAVIOUR: 'Detailed Weather + Fire Behaviour',
  SIMPLE_PLUS_PRESCRIPTIONS: 'Simple Weather + Prescriptions',
  DETAILED_PLUS_PRESCRIPTIONS: 'Detailed Weather + Prescriptions',
  ISP: 'ISP'
};

export const CENTER_MESSAGE_TYPES = {
  INFO: 'INFO',
  WARNING: 'WARNING'
};

export const FFM_OPTION =
  {
    MALLEE: 1,
    HEATH: 2
  };

export const VI_Scales = {
  scale: {
    '2350': 'Very Poor',
    '4700': 'Poor',
    '7050': 'Fair'
  },
  else: 'Good'
};

export const NO_AWS_NOTES = '<span>NOTE:</span> No AWS Observation data available because selected point is not within 10km of a Weather Station.';



// WEBPACK FOOTER //
// ./src/Constants.js